<template>
  <div class="manage">
    <div class="table-wrapper">
      <a-table :loading='loadingUser' :pagination="false" :columns="columns" :data-source="userList">
        <template slot="avatar" slot-scope="data">
          <a-avatar icon='user'></a-avatar>
        </template>
        <template slot="create_time" slot-scope="data">
          <span>{{data | dateFormat}}</span>
        </template>
        <template slot="status" slot-scope="data">
          <a-tag v-if="data===0" color='green'>正常</a-tag>
          <a-tag v-if="data===1" color='#ff0000'>锁定</a-tag>
        </template>
        <template slot="actions">
          <a-button type="link" icon='unlock'>锁定账户</a-button>
          <a-button type="link" icon='delete'>删除</a-button>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserList } from '../api/user'
export default {
  created() {
    this.requestData()
  },
  data() {
    return {
      loadingUser: false,
      userList: [],
      columns: [
        {
          title: '#id',
          width: 80,
          align: 'center',
          dataIndex: 'id'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '用户名',
          align: 'right',
          dataIndex: 'nickname'
        },
        {
          title: '邮箱',
          dataIndex: 'email'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 250,
          scopedSlots: { customRender: 'create_time' }
        },
        {
          title: '手机',
          dataIndex: 'phone'
        },
        {
          title: '状态',
          width: 100,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          width: 300,
          align: 'center',
          scopedSlots: { customRender: 'actions' }
        },
      ]
    }
  },
  methods: {
    async requestData() {
      this.loadingUser = true
      try {
        const data = await getUserList()
        this.userList = data
      } finally {
        this.loadingUser = false
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.table-wrapper {
  background: white;
}
</style>